<template>
  <div :class="`product-code ${minimal ? 'product-code-minimal' : ''}`">
    <v-layout>
      <!-- Shop page bottom redeem code section. Displays banner -->
      <v-flex v-if="!minimal" xs12>
        <v-card dark height="130px">
          <v-layout wrap align-center justify-center fill-height>
            <v-flex xs12 sm8>
              <v-card-text class="text-left">
                <div class="text-h5 font-weight-bold product-code-headline">
                  {{ $t('store.productCode.haveCode') }}
                </div>
                <div>
                  {{ $t('store.productCode.redeemDesc') }}
                </div>
              </v-card-text>
            </v-flex>
            <v-flex xs12 sm2>
              <v-card-actions class="pa-0">
                <v-dialog
                  v-model="dialog"
                  persistent
                  :max-width="
                    selectedLicense &&
                    selectedLicense.id &&
                    selectedLicense.id !== licenseCreateIDNum &&
                    hasSelectedLicense
                      ? '90%'
                      : '600'
                  "
                >
                  <template #activator="{ on }">
                    <v-btn
                      :color="`${$vuetify.theme.dark ? 'primary' : 'primary no-dark'}`"
                      style="margin: 0 auto; width: 95%"
                      v-on="on"
                    >
                      {{ $t('store.productCode.enterHere') }}
                    </v-btn>
                  </template>
                  <v-card
                    :class="[
                      productKeyError || productKeySuccess ? 'rounded-bl-0 rounded-br-0' : '',
                    ]"
                  >
                    <v-card-title>
                      <span class="text-h5">{{ $t('store.productCode.redeemProductKey') }}</span>
                      <v-spacer></v-spacer>
                      <v-btn
                        :color="`${$vuetify.theme.dark ? 'primary lighten-1' : 'primary'}`"
                        icon
                        @click="closeDialog"
                      >
                        <v-icon>close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text>
                      <v-row wrap>
                        <v-col
                          cols="12"
                          :lg="
                            selectedLicense &&
                            selectedLicense.id &&
                            selectedLicense.id !== licenseCreateIDNum &&
                            hasSelectedLicense
                              ? '5'
                              : '12'
                          "
                          class="pr-4 pl-0"
                        >
                          <v-form ref="form" v-model="isFormValid" lazy-validation>
                            <v-card flat>
                              <v-card-title>
                                <v-flex xs12 :sm10="!scanningEnabled" :sm8="scanningEnabled" pr-4>
                                  <v-text-field
                                    ref="productKey"
                                    v-model="$v.productKey.$model"
                                    v-mask="'NNNNN-NNNNN-NNNNN-NNNNN'"
                                    name="productKey"
                                    hint="XXXXX-XXXXX-XXXXX-XXXXX"
                                    placeholder="XXXXX-XXXXX-XXXXX-XXXXX"
                                    prepend-icon="vpn_key"
                                    return-masked-value
                                    clearable
                                    :label="$t('store.productCode.productKey')"
                                    :counter="23"
                                    :error-messages="keyErrors"
                                    @input="productKeyChange(productKey, $v.productKey)"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex v-if="scanningEnabled" xs1 sm1 class="qr-btn">
                                  <v-btn icon @click.native="scanQR">
                                    <v-tooltip top>
                                      <template #activator="{ on, attrs }">
                                        <v-icon large v-bind="attrs" v-on="on">
                                          mdi-qrcode-scan
                                        </v-icon>
                                      </template>
                                      <span>{{ $t('store.productCode.scanCode') }}</span>
                                    </v-tooltip>
                                  </v-btn>
                                </v-flex>
                                <v-flex xs12 sm2>
                                  <v-btn
                                    block
                                    color="primary"
                                    :disabled="
                                      !productKey ||
                                      productKeyError ||
                                      !isFormValid ||
                                      redeemedError ||
                                      !hasSelectedLicense
                                    "
                                    @click.native="
                                      submitProductKey(
                                        productKey,
                                        selectedLicense,
                                        isSkuKey,
                                        isSubscription,
                                        product,
                                        products
                                      )
                                    "
                                  >
                                    {{ $t('store.general.submit') }}
                                  </v-btn>
                                </v-flex>
                                <!-- <v-flex xs12>
                                  <div class="progress progress-camera" v-if="loadingCamera">
                                    <pulse-loader
                                      class="text-center"
                                      :color="loaderColor"
                                      :size="loaderSize"
                                    ></pulse-loader>
                                  </div>
                                  <transition name="fadeDown" mode="out-in" appear>
                                    <qrcode-stream
                                      v-if="scan"
                                      :camera="camera"
                                      @decode="onDecode"
                                      @init="onInit"
                                      :track="this.paintOutline"
                                    >
                                      <div v-if="validationSuccess" class="validation-success">
                                        Valid Product Key
                                      </div>

                                      <div v-if="validationFailure" class="validation-failure">
                                        Invalid Product Key!
                                      </div>

                                      <div v-if="cameraAccessFailure" class="validation-failure">
                                        Camera access not enabled.
                                      </div>

                                      <div v-if="validationPending" class="validation-pending">
                                        Product key validation in progress...
                                      </div>
                                    </qrcode-stream>
                                  </transition>
                                </v-flex> -->
                              </v-card-title>

                              <div v-if="loadingKeyData || processingProductKey" class="progress">
                                <pulse-loader
                                  class="text-center"
                                  :color="loaderColor"
                                  :size="loaderSize"
                                ></pulse-loader>
                              </div>
                              <v-flex
                                v-if="
                                  !loadingKeyData &&
                                  addonKeyEnabled &&
                                  !productKeyError &&
                                  productKey &&
                                  isDualKey
                                "
                                class="pl-4 pr-4"
                              >
                                <span
                                  v-if="isSubscription && !mobileSubBlock"
                                  class="text-subtitle-1 subheading-block pb-2"
                                >
                                  {{ $t('store.productCode.subscriptionKeyInfo') }}
                                </span>
                              </v-flex>
                              <v-flex
                                v-else-if="
                                  !loadingKeyData &&
                                  addonKeyEnabled &&
                                  !productKeyError &&
                                  productKey
                                "
                                class="pl-4 pr-4"
                              >
                                <span
                                  v-if="isSubscription && !mobileSubBlock"
                                  class="text-subtitle-1 subheading-block pb-2"
                                >
                                  {{ $t('store.productCode.subscriptionKeyInfo') }}
                                </span>
                                <span
                                  v-if="!mobileSubBlock && !isUserPermissionSingle"
                                  class="text-subtitle-1"
                                >
                                  {{ $t('store.productCode.licenseSelect') }}
                                </span>

                                <v-radio-group
                                  v-if="filteredLicenseList.length > 0 && !isUserPermissionSingle"
                                  v-model="selectedLicense"
                                  class="license-list"
                                  hide-details
                                >
                                  <v-radio
                                    v-for="n in filteredLicenseList"
                                    :key="n.id"
                                    :label="`${n.text} ${
                                      !n.newLicense
                                        ? `(${
                                            n.clientName
                                              ? `${n.clientName} / ${n.id.substr(0, 8)}`
                                              : n.id.substr(0, 8)
                                          })`
                                        : ''
                                    }`"
                                    :value="n"
                                  ></v-radio>
                                </v-radio-group>
                                <v-alert
                                  v-else-if="!isUserPermissionSingle"
                                  :color="`${$vuetify.theme.dark ? 'warning' : 'error'}`"
                                  icon="warning"
                                  outlined
                                >
                                  <span v-if="mobileSubBlock">
                                    {{ $t('store.general.mobileSubscriptionBlock') }}
                                  </span>
                                  <span v-if="isSubscription">
                                    {{ $t('store.general.noLicensesSubscriptionRedeem') }}
                                  </span>
                                  <span v-else>
                                    {{ $t('store.general.noLicensesProductRedeem') }}
                                  </span>
                                </v-alert>
                              </v-flex>
                            </v-card>
                          </v-form>
                        </v-col>

                        <v-divider
                          v-if="
                            selectedLicense &&
                            selectedLicense.id &&
                            selectedLicense.id !== licenseCreateIDNum &&
                            filteredLicenseList &&
                            filteredLicenseList.length &&
                            hasSelectedLicense
                          "
                          vertical
                        ></v-divider>

                        <v-col
                          v-if="
                            selectedLicense &&
                            selectedLicense.id &&
                            selectedLicense.id !== licenseCreateIDNum &&
                            filteredLicenseList &&
                            filteredLicenseList.length &&
                            hasSelectedLicense
                          "
                          class="pl-4 pr-0"
                          cols="12"
                          :lg="
                            selectedLicense &&
                            selectedLicense.id &&
                            selectedLicense.id !== licenseCreateIDNum &&
                            hasSelectedLicense
                              ? '7'
                              : '0'
                          "
                        >
                          <transition-group name="fadeDown" appear>
                            <LicenseItem
                              v-for="license in foundLicense"
                              :key="license.id"
                              :license="license"
                              :expired="checkLicense(license)"
                              :loading="loadingKeyData"
                              :is-loading="loadingKeyData"
                              :license-type="license.type"
                            />
                          </transition-group>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions v-if="!processingProductKey">
                      <v-spacer></v-spacer>
                      <v-btn
                        v-if="!productKey"
                        text
                        :color="`${$vuetify.theme.dark ? 'primary lighten-1' : 'primary'}`"
                        @click="closeDialog"
                      >
                        {{ $t('store.general.close') }}
                      </v-btn>

                      <v-btn
                        v-else-if="!loadingKeyData && selectedLicense && selectedLicense.id"
                        color="primary"
                        :disabled="
                          !productKey ||
                          productKeyError ||
                          !isFormValid ||
                          redeemedError ||
                          !hasSelectedLicense
                        "
                        @click.native="
                          submitProductKey(
                            productKey,
                            selectedLicense,
                            isSkuKey,
                            isSubscription,
                            product,
                            products
                          )
                        "
                      >
                        {{ $t('store.general.submit') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>

                  <transition v-if="!isDualKey" name="bounce">
                    <ProductCodeMessage
                      :error="productKeyError || redeemedError"
                      :success="productKeySuccess"
                      :error-message="errorMessage || redeemedErrorMessage"
                      :product-key="productKey"
                      @dismissKey="dismissKeyMessage"
                    />
                  </transition>
                </v-dialog>
              </v-card-actions>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <!-- Redeem button not full footer banner -->
      <!-- ==================================================================================== -->
      <v-flex v-else xs12 class="py-0">
        <v-card-actions class="pa-0">
          <v-dialog
            v-model="dialog"
            persistent
            :max-width="
              selectedLicense &&
              selectedLicense.id &&
              selectedLicense.id !== licenseCreateIDNum &&
              hasSelectedLicense
                ? '90%'
                : '600'
            "
          >
            <template #activator="{ on }">
              <v-btn
                :color="`${$vuetify.theme.dark ? '' : 'secondary'}`"
                :class="`custom-button ${$vuetify.theme.dark ? 'custom-button-dark' : ''}`"
                block
                dark
                v-on="on"
              >
                {{ buttonText }}
              </v-btn>
            </template>
            <v-card
              :min-height="
                selectedLicense &&
                selectedLicense.id &&
                selectedLicense.id !== licenseCreateIDNum &&
                hasSelectedLicense
                  ? '400'
                  : ''
              "
              :class="[productKeyError || productKeySuccess ? 'rounded-bl-0 rounded-br-0' : '']"
            >
              <v-card-title>
                <span class="text-h5">{{ $t('store.productCode.redeemProductKey') }}</span>
                <v-spacer></v-spacer>
                <v-btn
                  :color="`${$vuetify.theme.dark ? 'primary lighten-1' : 'primary'}`"
                  icon
                  @click="closeDialog"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-row wrap>
                  <v-col
                    cols="12"
                    :lg="
                      selectedLicense &&
                      selectedLicense.id &&
                      selectedLicense.id !== licenseCreateIDNum &&
                      hasSelectedLicense
                        ? '5'
                        : '12'
                    "
                    class="pr-4 pl-0"
                  >
                    <v-form ref="form" v-model="isFormValid" lazy-validation>
                      <v-card flat>
                        <v-card-title>
                          <v-flex xs12 :sm10="!scanningEnabled" :sm8="scanningEnabled" pr-4>
                            <v-text-field
                              ref="productKey"
                              v-model="$v.productKey.$model"
                              v-mask="'NNNNN-NNNNN-NNNNN-NNNNN'"
                              name="productKey"
                              hint="XXXXX-XXXXX-XXXXX-XXXXX"
                              placeholder="XXXXX-XXXXX-XXXXX-XXXXX"
                              prepend-icon="vpn_key"
                              return-masked-value
                              clearable
                              :label="$t('store.productCode.productKey')"
                              :counter="23"
                              :error-messages="keyErrors"
                              @click:clear="clearProductKeyField"
                              @input="productKeyChange(productKey, $v.productKey)"
                            ></v-text-field>
                          </v-flex>
                          <v-flex v-if="scanningEnabled" xs1 sm1 class="qr-btn">
                            <v-btn icon @click.native="scanQR">
                              <v-tooltip top>
                                <template #activator="{ on, attrs }">
                                  <v-icon large v-bind="attrs" v-on="on"> mdi-qrcode-scan </v-icon>
                                </template>
                                <span>{{ $t('store.productCode.scanCode') }}</span>
                              </v-tooltip>
                            </v-btn>
                          </v-flex>
                          <v-flex xs12 sm2>
                            <v-btn
                              block
                              color="primary"
                              :disabled="
                                !productKey ||
                                productKeyError ||
                                !isFormValid ||
                                redeemedError ||
                                !hasSelectedLicense
                              "
                              @click.native="
                                submitProductKey(
                                  productKey,
                                  selectedLicense,
                                  isSkuKey,
                                  isSubscription,
                                  product,
                                  products
                                )
                              "
                            >
                              {{ $t('store.general.submit') }}
                            </v-btn>
                          </v-flex>
                        </v-card-title>

                        <div v-if="loadingKeyData || processingProductKey" class="progress">
                          <pulse-loader
                            class="text-center"
                            :color="loaderColor"
                            :size="loaderSize"
                          ></pulse-loader>
                        </div>
                        <v-flex
                          v-if="
                            !loadingKeyData &&
                            addonKeyEnabled &&
                            !productKeyError &&
                            productKey &&
                            isDualKey
                          "
                          class="px-4"
                        >
                          <span
                            v-if="isSubscription && !mobileSubBlock"
                            class="text-subtitle-1 subheading-block pb-2"
                          >
                            {{ $t('store.productCode.subscriptionKeyInfo') }}
                          </span>
                        </v-flex>
                        <v-flex
                          v-else-if="
                            !loadingKeyData && addonKeyEnabled && !productKeyError && productKey
                          "
                          class="px-"
                        >
                          <span
                            v-if="isSubscription && !mobileSubBlock"
                            class="text-subtitle-1 subheading-block pb-2"
                          >
                            {{ $t('store.productCode.subscriptionKeyInfo') }}
                          </span>
                          <span
                            v-if="!mobileSubBlock && !isUserPermissionSingle"
                            class="text-subtitle-1"
                          >
                            {{ $t('store.productCode.licenseSelect') }}
                          </span>

                          <v-radio-group
                            v-if="filteredLicenseList.length > 0 && !isUserPermissionSingle"
                            v-model="selectedLicense"
                            class="license-list"
                            hide-details
                          >
                            <v-radio
                              v-for="n in filteredLicenseList"
                              :key="n.id"
                              :label="`${n.text} ${
                                !n.newLicense
                                  ? `(${
                                      n.clientName
                                        ? `${n.clientName} / ${n.id.substr(0, 8)}`
                                        : n.id.substr(0, 8)
                                    })`
                                  : ''
                              }`"
                              :value="n"
                            ></v-radio>
                          </v-radio-group>

                          <v-alert
                            v-else-if="!isUserPermissionSingle"
                            :color="`${$vuetify.theme.dark ? 'warning' : 'error'}`"
                            icon="warning"
                            outlined
                          >
                            <span v-if="mobileSubBlock">
                              {{ $t('store.general.mobileSubscriptionBlock') }}
                            </span>
                            <span v-else-if="isSubscription">
                              {{ $t('store.general.noLicensesSubscriptionRedeem') }}
                            </span>
                            <span v-else>
                              {{ $t('store.general.noLicensesProductRedeem') }}
                            </span>
                          </v-alert>
                        </v-flex>
                      </v-card>
                    </v-form>
                  </v-col>

                  <v-divider
                    v-if="
                      selectedLicense &&
                      selectedLicense.id &&
                      selectedLicense.id !== licenseCreateIDNum &&
                      filteredLicenseList &&
                      filteredLicenseList.length &&
                      hasSelectedLicense
                    "
                    vertical
                  ></v-divider>

                  <v-col
                    v-if="
                      selectedLicense &&
                      selectedLicense.id &&
                      selectedLicense.id !== licenseCreateIDNum &&
                      filteredLicenseList &&
                      filteredLicenseList.length &&
                      hasSelectedLicense
                    "
                    cols="12"
                    :lg="selectedLicense && selectedLicense.id ? '7' : '0'"
                  >
                    <LicenseItem
                      v-for="license in foundLicense"
                      :key="license.id"
                      :license="license"
                      :expired="checkLicense(license)"
                      :loading="loadingKeyData"
                      :is-loading="loadingKeyData"
                      :license-type="license.type"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions v-if="!processingProductKey">
                <v-spacer></v-spacer>
                <v-btn
                  v-if="!productKey"
                  text
                  :color="`${$vuetify.theme.dark ? 'primary lighten-1' : 'primary'}`"
                  @click="closeDialog"
                >
                  {{ $t('store.general.close') }}
                </v-btn>

                <v-btn
                  v-else-if="!loadingKeyData && selectedLicense && selectedLicense.id"
                  color="primary"
                  :disabled="
                    !productKey ||
                    productKeyError ||
                    !isFormValid ||
                    redeemedError ||
                    !hasSelectedLicense
                  "
                  @click.native="
                    submitProductKey(
                      productKey,
                      selectedLicense,
                      isSkuKey,
                      isSubscription,
                      product,
                      products
                    )
                  "
                >
                  {{ $t('store.general.submit') }}
                </v-btn>
              </v-card-actions>
            </v-card>

            <transition v-if="!isDualKey" name="bounce">
              <ProductCodeMessage
                :error="productKeyError || redeemedError"
                :success="productKeySuccess"
                :error-message="errorMessage || redeemedErrorMessage"
                :product-key="productKey"
                @dismissKey="dismissKeyMessage"
              />
            </transition>
          </v-dialog>
        </v-card-actions>
      </v-flex>
    </v-layout>

    <v-dialog v-model="scan" v-resize="utility_onResize" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ $t('store.productCode.scanCode') }}
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <div v-if="loadingCamera" class="text-center loading-box">
              <div class="camera-loading">
                <v-progress-circular
                  :size="isMobile ? 150 : 200"
                  :width="10"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </div>
            </div>
            <transition name="fadeDown" mode="out-in" appear>
              <qrcode-stream
                v-if="scan"
                :camera="camera"
                :track="paintOutline"
                class="pt-4 pb-2"
                @decode="onDecode"
                @init="onInit"
              >
                <div v-if="validationSuccess" class="validation-success">
                  {{ $t('store.productCode.camera.validKeyMsg') }}
                </div>
                <div v-if="validationFailure" class="validation-failure">
                  {{ $t('store.productCode.camera.invalidKeyMsg') }}!
                </div>
                <div v-if="cameraAccessFailure" class="validation-failure">
                  {{ $t('store.productCode.camera.noCameraAccessMsg') }}.
                </div>
                <div v-if="cameraAccessDenied" class="validation-failure">
                  {{ $t('store.productCode.camera.pleaseEnableMsg') }}.
                </div>
                <div v-if="cameraAccessGeneralError" class="validation-failure">
                  {{ $t('store.productCode.camera.generalCameraError') }}.
                </div>
                <div v-if="validationPending" class="validation-pending">
                  {{ $t('store.productCode.camera.keyValidationMsg') }}...
                </div>
              </qrcode-stream>
            </transition>
          </v-flex>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeDialog"> close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="newLicenseAnswerDialog"
      transition="dialog-bottom-transition"
      width="500"
      overlay-opacity="0.6"
      persistent
    >
      <v-card :dark="$vuetify.theme.dark ? true : false">
        <v-card-title class="text-h5 primary white--text" style="word-break: break-word">
          {{ $t('info.attention').toUpperCase() }}!
        </v-card-title>

        <v-card-text class="text-subtitle-1 pt-3">
          {{ $t('licenses.newLicenseMsg') }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="handleDialogResponse(false, 'newLicenseAnswerDialog')">
            {{ $t('general.cancel') }}
          </v-btn>
          <v-btn
            text
            color="primary"
            @click.native="handleDialogResponse(true, 'newLicenseAnswerDialog')"
          >
            {{ $t('general.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// TODO Rework this component to be used everywhere
import { mapGetters } from 'vuex';
import { validationMixin } from 'vuelidate';
import isEmpty from 'lodash/isEmpty';
import { isBefore, parseISO } from 'date-fns';
import { QrcodeStream } from 'vue-qrcode-reader';
import meMixin from '@/mixins/meMixin';
import utilityMixin from '@/mixins/utilityMixin';
import ProductCodeMessage from '@/components/ProductCodeMessage';
import LicenseItem from '@/components/settings/LicenseItem';
import { isDev } from '@/utils/helpers';

import {
  licenseBlacklistCheck,
  licenseWhitelistCheck,
  allowCoreCheck,
  allowCoreCheckAllProducts,
} from '@/lib/licenseCheck';

const touchMap = new WeakMap();

//* Custom validation
const keyCheck = (value) => {
  if (!value) return true;
  const pattern = /([A-Za-z0-9]){5}-([A-Za-z0-9]){5}-([A-Za-z0-9]){5}-([A-Za-z0-9]){5}/;
  return pattern.test(value?.trim());
};

export default {
  name: 'ProductKey',

  components: {
    ProductCodeMessage,
    LicenseItem,
    QrcodeStream,
  },
  mixins: [meMixin, validationMixin, utilityMixin],
  props: {
    minimal: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: '',
    },
  },

  validations: {
    productKey: {
      keyCheck,
    },
  },

  data() {
    return {
      dialog: false,
      isFormValid: true,
      productKey: '',
      addonKeyEnabled: false,
      selectedLicense: {},
      hasSelectedLicense: false,
      isSkuKey: false,
      isSubscription: false,
      isUserPermissionSingle: false,
      isUserPermissionMulti: false,
      hasLicense: false,
      product: {},
      products: [],
      redeemedError: false,
      redeemedErrorMessage: null,
      loadingKeyData: false,
      processingProductKey: false,
      allProductWhitelist: [],
      allProductBlacklist: [],
      loaderColor: '#BA2127',
      loaderSize: '1.2em',
      mobileSubBlock: false,
      foundLicense: [],
      isDualKey: false,

      licenseCreateIDNum: '000000',
      licenseCreateIDVal: 'create',

      // Create new license dialog values
      newLicenseAnswerDialog: false,
      dialogResolve: null, // To store the resolver of the promise

      //* QR Scanning
      camera: 'auto',
      isValid: undefined,
      hasCameraAccess: undefined,
      cameraAccessEnabled: undefined,
      generalCameraError: undefined,
      scan: false,
      loadingCamera: false,

      //* enable or disable scan button
      scanningEnabled: false,

      // TODO testing
      transactions: null,
      blockRedeem: false,

      rules: {
        // prodKey: [
        //   (k) => !!k || 'Product key is required',
        //   (k) =>
        //     (k && k?.trim().length === 23) ||
        //     'Product key must be 20 characters long separated by dashes (23 total)',
        //   (k) => {
        //     //* Testing out using input mask to avoid having to type dashes
        //     //* mask="NNNNN-NNNNN-NNNNN-NNNNN" needs to be added to text-field along with return-unmasked-value
        //     // const code = `${k.slice(0, 5)}${k.slice(5, 10)}${k.slice(10, 15)}${k.slice(15, 23)}`
        //     // console.log('code:', code)
        //     // console.log('pattern:', pattern.test(code))
        //     const pattern = /([A-Za-z0-9]){5}-([A-Za-z0-9]){5}-([A-Za-z0-9]){5}-([A-Za-z0-9]){5}/;
        //     return pattern.test(k?.trim()) || 'Invalid Product Key.';
        //   },
        // ],
      },
    };
  },

  computed: {
    ...mapGetters({
      licenseList: 'licenses/licenseList',
      multiLicenseList: 'licenses/multiLicenseList',
      mobileLicenseList: 'licenses/mobileLicenseList',
      loadingKey: 'licenses/loadingKey',
      productKeyData: 'licenses/productKey',
      productKeyError: 'licenses/productKeyError',
      productKeySuccess: 'licenses/productKeySuccess',
      errorMessage: 'licenses/errorMessage',
      hasReseller: 'users/hasReseller',
      hasClubhouse: 'users/hasClubhouse',
      limitedUser: 'users/limitedUser',
    }),

    fullLicenseList() {
      const licenses = [];

      this.licenseList.map((license) => {
        licenses.push({
          ...license,
          text: license?.license?.name,
          id: license?.license?.id,
          type: license?.license?.license_key === 'desktop_license' ? 'Desktop' : 'Mobile',
          courses: license.courses,
          permissions: license.permissions,
          trackingSystems: license.trackingSystems,
          clientName: license?.clientName,
        });
      });
      this.multiLicenseList.map((license) => {
        licenses.push({
          ...license,
          text: license?.license?.name,
          id: license?.license?.id,
          type: 'Desktop',
          courses: license.courses,
          permissions: license.permissions,
          trackingSystems: license.trackingSystems,
          clientName: license?.clientName,
        });
      });
      this.mobileLicenseList.map((license) => {
        licenses.push({
          ...license,
          text: license?.license?.name,
          id: license?.license?.id,
          type: 'Mobile',
          courses: license.courses,
          permissions: license.permissions,
          trackingSystems: license.trackingSystems,
          clientName: license?.clientName,
        });
      });

      return licenses;
    },

    filteredLicenseList() {
      const { type, products = [] } = this.productKeyData;
      let allowCoreAllProducts = false;

      const filteredLicenses = this.fullLicenseList.filter((license) => {
        // Ignoring type of license now. Allow to redeem to desktop or mobile
        if (license?.id) {
          // console.log('here====');
          // if (license.type.toLowerCase() === type) {
          const isNotBlacklisted = !licenseBlacklistCheck(license, this.productBlacklist);
          const isWhitelisted = licenseWhitelistCheck(license, this.productWhitelist);

          //* SkyTrak licenses are allowed to redeem a product key
          //* If that changes, add this back in
          // const isNotSkyTrak = !licenseSkyTrakCheck(license);

          return isNotBlacklisted && isWhitelisted;

          // Ignoring type of license now. Allow to redeem to desktop or mobile
          // return license.type.toLowerCase() === type && isNotBlacklisted && isWhitelisted;
          // return false; //* for testing no available licenses
        }
        return false;
      });

      if (products?.length) {
        allowCoreAllProducts = allowCoreCheckAllProducts(products);
      }

      if (
        (allowCoreCheck(this.productKeyData?.product) ||
          // allowCoreCheck(this.getRedeemFirstProduct) ||
          allowCoreAllProducts) &&
        !this.mobileSubBlock
      ) {
        const desktopProductType = this.productWhitelist?.some((item) => {
          return item.includes('desktop_license');
        });

        // Default to desktop type license only as of 10-15-24
        return [
          ...filteredLicenses,
          {
            // id: '000000',
            id: this.licenseCreateIDNum,
            display: this.$t('licenses.createNewLicense'),
            type: desktopProductType ? 'desktop' : 'desktop',
            text: this.$t('licenses.createNewLicense'),

            // id: 'create',
            // display: 'Create New License',
            // text: 'Create New License',

            newLicense: true,
          },
        ];
      }

      return filteredLicenses;
    },

    // No longer using. Merging whitelist and blacklist from all products
    getRedeemFirstProduct() {
      if (this.productKeyData?.products) {
        let redeemFirst = this.productKeyData?.products.find((product) => {
          return (
            product.productType.type.toLowerCase() === 'purchase' &&
            product.productCategory === 'trackingSystem'
          );
        });

        if (!redeemFirst) {
          redeemFirst = this.productKeyData?.products.find((product) => {
            return (
              product.productType.type.toLowerCase() === 'purchase' &&
              product.productCategory === 'courseContent'
            );
          });
        }
        // console.log('redeemFirst2:', redeemFirst);
        return redeemFirst;
      }
      return {};
    },

    //* Get blacklist from all products combined
    getAllProductBlacklist() {
      if (this.productKeyData?.products) {
        const { products = [] } = this.productKeyData;
        let mergedBlacklist = [];
        products?.forEach((product) => {
          const productBlacklist = Array.isArray(product?.blacklist) ? product.blacklist : [];
          mergedBlacklist = [...mergedBlacklist, ...productBlacklist];
        });
        return [...new Set([...mergedBlacklist])];
      }
      return [];
    },

    //* Get whitelist from all products combined
    getAllProductWhitelist() {
      if (this.productKeyData?.products) {
        const { products = [] } = this.productKeyData;
        let mergedWhitelist = [];
        products?.forEach((product) => {
          const productWhitelist = Array.isArray(product?.whitelist) ? product.whitelist : [];
          mergedWhitelist = [...mergedWhitelist, ...productWhitelist];
        });
        return [...new Set([...mergedWhitelist])];
      }
      return [];
    },

    productWhitelist() {
      if (this.productKeyData?.product) {
        return this.productKeyData?.product?.whitelist;
      }

      if (this.productKeyData?.products) {
        this.allProductWhitelist = this.getAllProductWhitelist;
        return this.allProductWhitelist;

        // const redeemFirst = this.getRedeemFirstProduct;
        // this.firstProduct = this.getRedeemFirstProduct;
        // return redeemFirst?.whitelist;
      }
      return [];
    },

    productBlacklist() {
      if (this.productKeyData?.product) {
        return this.productKeyData?.product?.blacklist;
      }

      if (this.productKeyData?.products) {
        this.allProductBlacklist = this.getAllProductBlacklist;
        return this.allProductBlacklist;

        // this.firstProduct = this.getRedeemFirstProduct;
        // const redeemFirst = this.getRedeemFirstProduct;
        // return redeemFirst?.blacklist;
      }

      return [];
    },

    keyErrors() {
      const errors = [];
      if (!this.$v.productKey.$dirty) return errors;
      !this.$v.productKey.keyCheck && errors.push('Invalid Product Key');
      return errors;
    },

    validationPending() {
      return this.isValid === undefined && this.camera === 'off';
    },

    validationSuccess() {
      return this.isValid === true;
    },

    validationFailure() {
      return this.isValid === false;
    },

    cameraAccessFailure() {
      return this.hasCameraAccess === false;
    },

    cameraAccessDenied() {
      return this.cameraAccessEnabled === false;
    },

    cameraAccessGeneralError() {
      return this.generalCameraError === true;
    },
  },

  watch: {
    dialog(newVal, _) {
      if (newVal && (this.$route.name !== 'licenseSettings' || this.$route.path.includes('shop'))) {
        if (!this.fullLicenseList?.length) {
          this.$store.dispatch('licenses/all');
          //* If AGNOSTICLICENSE var is active, disable this mobile license call
          if (!isDev()) {
            this.$store.dispatch('licenses/mobile');
          }
        }
        // if (!this.licenseList?.length && !this.multiLicenseList?.length) {
        //   this.$store.dispatch('licenses/all');
        // }
        // if (!this.mobileLicenseList?.length) {
        //   this.$store.dispatch('licenses/mobile');
        // }
      }
    },

    selectedLicense(newVal) {
      if (newVal?.id) {
        this.hasSelectedLicense = true;

        const license = this.filteredLicenseList.filter((item) => {
          return item.id === newVal.id;
        });
        this.foundLicense = license;

        // TODO check for transactions potentially to block delay time keys
        // * Not sure it's needed - double check
        setTimeout(() => {
          this.transactions = this.$store.getters['transactions/show'];
          if (this.productKeyData.delay_time && this.transactions?.length) {
            this.blockRedeem = true;
          }
        }, 500);

        //* LicenseItem checks transactions already
        // if (license?.[0]?.id) {
        //   this.$store.dispatch('transactions/show', { id: license?.[0]?.id }).then((res) => {
        //     console.log('res:', res);
        //     this.transactions = res;

        //     if (this.productKeyData.delay_time && this.transactions?.length) {
        //       this.blockRedeem = true;
        //     }
        //   });
        // }
      } else {
        this.hasSelectedLicense = false;
        this.blockRedeem = false;
      }
    },
  },

  methods: {
    closeDialog() {
      this.dismissKeyMessage();
      this.dialog = false;
      this.scan = false;
      this.camera === 'off';
      this.isValid === undefined;
      this.loadingCamera === false;
      this.hasCameraAccess === undefined;
      this.cameraAccessEnabled === undefined;
      this.generalCameraError === undefined;
    },

    productKeyChange(key, vField) {
      // console.log('productKeyChange key:', key);
      if (vField) {
        this.delayTouch(vField);
      }

      this.$v.productKey.$model = this.$v.productKey.$model?.toUpperCase();
      this.addonKeyEnabled = false;
      this.isSubscription = false;
      this.product = {};
      this.redeemedError = false;
      this.redeemedErrorMessage = null;
      this.$store.dispatch('licenses/dismissKeyMessage', false);
      key = key?.trim();

      if (this.$v.productKey.$invalid) {
        return;
      }

      if (key && key.length === 23) {
        this.loadingKeyData = true;

        // @ Debounce the call to get product key details
        // * cancel pending call
        clearTimeout(this._timerId);

        // * delay new call 500ms
        this._timerId = setTimeout(() => {
          // * Remove any old product key data stored
          localStorage.removeItem('redeem_payload');
          localStorage.removeItem('redeem_productPayload');
          localStorage.removeItem('redeem_licenseID');

          if (this.getMe?.activated === false) {
            this.$root.vtoast.show({
              text: `${this.$t('store.productCode.activateAccount')}.`,
              color: 'error',
            });
            this.loadingKeyData = false;
            return;
          }

          this.$store
            .dispatch('licenses/getProductKey', key.toUpperCase())
            .then((res) => {
              console.log('res getProductKey:', res);
              if (res?.userID || res?.desktopLicenseID || res?.mobileLicenseID) {
                this.redeemedError = true;
                this.loadingKeyData = false;
                this.redeemedErrorMessage = `${this.$t('store.productCode.productKeyRedeemed')}.`;
                return;
              }
              if (res?.licenseKey) {
                this.redeemedError = true;
                this.loadingKeyData = false;
                this.redeemedErrorMessage = `${this.$t('store.productCode.productKeyInvalid')}.`;
                return;
              }
              if (res?.status === 'disabled') {
                this.redeemedError = true;
                this.loadingKeyData = false;
                this.redeemedErrorMessage = `${this.$t('store.productCode.productKeyInvalid')}.`;
                return;
              }

              this.hasLicense = res?.product?.licenseKey;

              if (!res?.product && !res?.products && res?.licenseKey) {
                this.hasSelectedLicense = true;
              }

              // if (res?.type === 'mobile') {
              //   res.type = 'desktop';
              // }

              // ignore if dual type key and convert to desktop type ====================
              // if (res?.type === 'dual') {
              //   res.type = 'desktop';
              // }

              if (res?.type === 'dual') {
                this.hasLicense = true;
                this.hasSelectedLicense = true;
                this.isDualKey = true;

                //* check for subscription for dual key
                const { products } = res;
                this.products = products;
                const subscriptionProduct = products?.find((product) => {
                  const { productCategory, productType } = product;
                  return (
                    productCategory === 'licenseSubscription' &&
                    productType?.type?.toLowerCase() === 'subscription' &&
                    product?.whitelist?.includes('desktop_license')
                  );
                });
                // console.log('subscriptionProduct:', subscriptionProduct);
                // console.log('productWhiteList', this.productWhitelist);

                if (subscriptionProduct) {
                  this.isSubscription = true;
                }
                // if (res?.skucodes?.length) {
                //   this.addonKeyEnabled = true;
                // }

                // this.isSkuKey = false;
                this.addonKeyEnabled = true;
                this.loadingKeyData = false;
                return;
              }

              //* Multi-sku check
              if (!this.hasLicense && res?.skucodes?.length) {
                this.isSkuKey = true;
                this.addonKeyEnabled = true;

                const { products } = res;
                this.products = products;

                const subscriptionProduct = products.find((product) => {
                  const { productCategory, productType } = product;
                  return (
                    productCategory === 'licenseSubscription' &&
                    productType.type.toLowerCase() === 'subscription'
                  );
                });

                const userPermissionProduct = products.find((product) => {
                  const { productCategory, productType } = product;
                  return (
                    productCategory === 'userPermission' &&
                    productType.type.toLowerCase() === 'purchase'
                  );
                });

                if (subscriptionProduct) {
                  this.isSubscription = true;
                }

                if (userPermissionProduct) {
                  this.isUserPermissionMulti = true;
                  // this.hasLicense = true; //* Don't bypass license selection as it's possible to need it
                  // this.hasSelectedLicense = true; //* Don't bypass license selection as it's possible to need it
                }

                if (
                  subscriptionProduct &&
                  subscriptionProduct.productCategory === 'licenseSubscription' &&
                  res?.type === 'mobile'
                ) {
                  this.mobileSubBlock = true;
                  this.addonKeyEnabled = true;
                  this.loadingKeyData = false;
                  return;
                }

                this.loadingKeyData = false;
                return res;
              }

              //* Single sku check
              if (res && res?.skucode && !this.hasLicense) {
                const {
                  product,
                  product: { productCategory, productType },
                  type,
                } = res;

                // ======= Original, was changed to include consumable as subscription for some reason
                // productCategory === 'licenseSubscription' &&
                // (productType?.type.toLowerCase() === 'subscription' ||
                //   productType?.type.toLowerCase() === 'consumable')
                // =====================

                (productCategory === 'licenseSubscription' ||
                  productType?.type.toLowerCase() === 'subscription') &&
                productType?.type.toLowerCase() !== 'consumable' &&
                productType?.type.toLowerCase() !== 'purchase'
                  ? (this.isSubscription = true)
                  : (this.isSubscription = false);

                //* check for user permission category
                if (productCategory === 'userPermission') {
                  this.isUserPermissionSingle = true;
                  this.hasLicense = true; //* Bypass license selection as we don't need it
                  this.hasSelectedLicense = true; //* Bypass license selection as we don't need it
                }

                // Do we need? Bypassing type now...
                // if (
                //   this.isSubscription &&
                //   type === 'mobile' &&
                //   productCategory === 'licenseSubscription'
                // ) {
                //   this.mobileSubBlock = true;
                //   this.addonKeyEnabled = true;
                //   this.loadingKeyData = false;
                //   return;
                // }

                this.product = product;
                this.isSkuKey = true;
                this.addonKeyEnabled = true;
                this.loadingKeyData = false;
                return res;
              }

              this.isSkuKey = false;
              this.addonKeyEnabled = false;
              this.loadingKeyData = false;
            })
            .catch((err) => {
              console.error('error', err);
            });
        }, 500);
      }
    },

    async submitProductKey(key, license, isSkuKey, isSubscription, product, products) {
      if (this.limitedUser) {
        alert(
          'Your account is limited and does not allow for redeeming product keys. Please login using your email and password.'
        );
        this.closeDialog();
        return;
      }
      // console.log('submitProductKey =============================');
      // console.log('key:', key);
      // console.log('license:', license);
      // console.log('isSkuKey:', isSkuKey);
      // console.log('isSubscription:', isSubscription);
      // console.log('product:', product);
      // console.log('products:', products);
      // console.log('this.productKeyData:', this.productKeyData);

      this.processingProductKey = true;
      let payload = {};
      let licenseID = '';
      // const clientOS = this.productKeyData.type === 'desktop' ? 'windows' : 'ios';
      const clientOS =
        this.productKeyData.type === 'desktop'
          ? 'windows'
          : this.productKeyData.type === 'dual'
          ? 'dual'
          : 'ios';
      const multiSportProductType = this.productWhitelist?.some((item) => {
        return item.includes('multi_sport_license');
      });

      if (isSkuKey && !license.id && !this.isUserPermissionSingle && !this.isUserPermissionMulti) {
        alert('Please select a license.');
        this.processingProductKey = false;
        return;
      }

      if (license) {
        if (
          multiSportProductType &&
          (license?.id === this.licenseCreateIDVal || license?.id === this.licenseCreateIDNum)
        ) {
          licenseID = `create:multi_sport_core`;
        } else if (
          license?.id &&
          license?.id !== this.licenseCreateIDVal &&
          license?.id !== this.licenseCreateIDNum
        ) {
          licenseID = license.id;
        } else {
          // licenseID = `${multiSportProductType ? this.licenseCreateIDVal : license.id}${
          //   multiSportProductType &&
          //   (license?.id === this.licenseCreateIDVal || license?.id === this.licenseCreateIDNum)
          //     ? ':multi_sport_core'
          //     : ''
          // }`;
          licenseID = `${this.licenseCreateIDVal}${
            multiSportProductType &&
            (license?.id === this.licenseCreateIDVal || license?.id === this.licenseCreateIDNum)
              ? ':multi_sport_core'
              : license?.id === this.licenseCreateIDVal || license?.id === this.licenseCreateIDNum
              ? ':default'
              : ''
          }`;
        }
      }

      payload = {
        ...payload,
        productKey: key.trim().toUpperCase(),
        userID: this.getMe?.id,
        clientOS,
        delayTime: this.productKeyData?.delay_time || null,
      };
      // console.log('payload:', payload);

      //* Dual key, submit it - check for subscription
      // Check this======================================================
      // maybe remove
      if (this.productKeyData?.type === 'dual') {
        payload.dualKey = true;
        this.submitKey(payload, 'dual', null, null, products, isSubscription);
        return;
      }

      if (this.isUserPermissionSingle) {
        this.submitKey(payload);
        return;
      }

      if (license.id === this.licenseCreateIDVal || license.id === this.licenseCreateIDNum) {
        const confirmNewLicenseAnswer = await this.openDialog('newLicenseAnswerDialog');

        //* If it is creating a new license and contains a subscription
        //* proceed through checkout flow - not redeeming here
        if (confirmNewLicenseAnswer && isSkuKey && isSubscription && !this.hasLicense) {
          this.submitKey(payload, licenseID, license, product, products, true); //* is this the same?
          return;
        }

        //* If it is just creating a new license, submit and redeem
        if (confirmNewLicenseAnswer) {
          //* Submit the key after confirmation
          this.submitKey(payload, licenseID);
          return;
        }

        this.processingProductKey = false;
        return;
      }

      //* If it is redeeming to an existing license and has a subscription
      //* go through the checkout flow and then redeem key
      if (isSkuKey && isSubscription && !this.hasLicense) {
        this.submitKey(payload, licenseID, license, product, products, true);
        return;
      }

      //* If key doesn't contain a subscription and redeeming to an existing license
      //* Submit the key to redeem
      this.submitKey(payload, licenseID);
    }, // end of async submitProductKey

    //* Submit product key to redeem
    submitKey(payload, licenseID, license, product, products, hasSubscription) {
      // console.log('submitKey ====================================');
      // console.log('submitKey payload:', payload);
      // console.log('licenseID:', licenseID);
      // console.log('license:', license);
      // console.log('product:', product);
      // console.log('products:', products);
      // console.log('hasSubscription:', hasSubscription);

      // const updatedLicenseID =
      //   licenseID === this.licenseCreateIDNum ? this.licenseCreateIDVal : licenseID;
      const updatedLicenseID =
        licenseID === this.licenseCreateIDNum ? `${this.licenseCreateIDVal}:default` : licenseID;

      //* If key has a subscription, send through checkout flow and redeem there
      if (hasSubscription) {
        if (payload?.clientOS === 'dual') {
          //* Dual type key with sub needs to redeem first to get the license ID to add to cart
          //* Send to redeem then add to cart
          this.sendKeyForRedemption(
            payload,
            updatedLicenseID,
            hasSubscription,
            license,
            product,
            products
          );
          return;
        }

        //* Not dual type, add to cart and redeem after checkout
        this.addSubscriptionInformation(license, product, payload, products);
        return;
      }

      //* No subscription, just send the key to redeem
      this.sendKeyForRedemption(
        payload,
        updatedLicenseID,
        hasSubscription,
        license,
        product,
        products
      );
    },

    sendKeyForRedemption(payload, updatedLicenseID, hasSubscription, license, product, products) {
      // console.log('sendKeyForRedemption ======================================');
      // console.log('payload:', payload);
      // console.log('updatedLicenseID:', updatedLicenseID);
      // console.log('hasSubscription:', hasSubscription);
      // console.log('license:', license);
      // console.log('product:', product);
      // console.log('products:', products);
      // console.log('productWhitelist before=========:', this.productWhitelist);

      this.$store
        .dispatch('licenses/submitKey', {
          payload,
          licenseID: updatedLicenseID,
          isPermission: this.isUserPermissionSingle || this.isUserPermissionMulti,
        })
        .then((res) => {
          // console.log('submitKey res:', res);
          payload = { ...payload, ...res };
          this.addonKeyEnabled = false;
          this.isSubscription = false;
          this.hasSelectedLicense = false;

          if (!res || isEmpty(res)) {
            this.$root.vtoast.show({
              text: `There was a problem redeeming this product key.`,
              color: 'error',
            });
            this.processingProductKey = false;
            return;
          }

          setTimeout(() => {
            if (hasSubscription) {
              const createdLicenseID = payload.desktopLicenseID
                ? payload.desktopLicenseID
                : payload.mobileLicenseID;
              //* Add sub product to cart now for checkout info
              this.addSubscriptionInformation(
                license,
                product,
                payload,
                products,
                createdLicenseID
              );
              return;
            }

            //* If it is a user permission product, and specific to a clubhouse currently
            //* Find the new clubhouse details and redirect to the edit clubhouse page.
            if (this.isUserPermissionSingle || this.isUserPermissionMulti) {
              this.$store
                .dispatch('clubhouses/list', { deleteCache: true })
                .then(() => {
                  localStorage.setItem('userUpdated', true);
                  this.$store.dispatch('users/v3Me', { deleteCache: true });
                  this.$store
                    .dispatch('users/me', { bypass: true })
                    .then(() => {
                      const { club } = this.getMe;
                      // const [clubhouses] = this.getMeV3.clubhouses;

                      // TODO Update this to use v3 get me
                      this.newClubToSetup =
                        club?.find((item) => {
                          const pattern = /-/gi;
                          return (
                            item.status === 'default' ||
                            item.name === item.uuid.replace(pattern, '')
                          );
                        }) ?? null;

                      if (this.hasClubhouse && this.newClubToSetup?.id) {
                        setTimeout(() => {
                          //* Redirect to clubhouse edit here
                          this.$router.push({
                            name: 'clubhouseEdit',
                            params: {
                              clubhouseID: this.newClubToSetup.id,
                            },
                            query: {
                              newClubhouseSetup: true,
                            },
                          });
                        }, 1000);
                      }
                    })
                    .catch((err) => {
                      console.error(err);
                    });
                })
                .catch((err) => {
                  console.error('CLUB LIST', err);
                });
            }
            this.dismissKeyMessage(!res ? null : 'success', res?.type === 'dual');

            //* Just refetch all licenses. Preserves original sorting.
            this.$store.dispatch('licenses/all');
            //* If AGNOSTICLICENSE var is active, disable this mobile license call
            if (!isDev()) {
              this.$store.dispatch('licenses/mobile');
            }
            this.processingProductKey = false;
          }, 3000);
        })
        .catch((error) => {
          console.error('error:', error);
          //* custom error check to see if no license ID was found
          if (error.status === 428 || error.type === 'licenseError') {
            this.$root.vtoast.show({
              text: `${error.msg}`,
              color: 'error',
            });
            this.processingProductKey = false;
            this.hasSelectedLicense = false;
            return;
          }
          this.$root.vtoast.show({
            text: `Error P1004: There was a problem redeeming this product key.`,
            color: 'error',
          });
          this.processingProductKey = false;
          this.hasSelectedLicense = false;
        });
    },

    //* Add subscription product to cart to get customer info for subscription
    async addSubscriptionInformation(license, product, payload, products, createdLicenseID) {
      // console.log('addSubscriptionInformation =======================================');
      // console.log('license:', license);
      // console.log('product:', product);
      // console.log('payload:', payload);
      // console.log('products:', products);
      // console.log('createdLicenseID:', createdLicenseID);

      const productPayload = this.getProductPayload(license, product, products, createdLicenseID);
      if (!productPayload) {
        return;
      }

      //* If dual key with subscription
      //* Set bypassAddToCartPayAndPauseCheck so that we can still add product to cart
      if (payload.clientOS === 'dual') {
        // productPayload.multiKeyRedemption = false;
        productPayload.bypassAddToCartPayAndPauseCheck = true;
      }

      await this.$store.dispatch('shop/getCart');
      this.$store
        .dispatch('shop/deleteCart')
        .then(() => {
          this.$store.dispatch('shop/createCart').then((res) => {
            // console.log('createCart res:', res);
            if (!product) {
              product = productPayload;
            }
            product.cartID = res.cartID;

            productPayload.delay_start = true;

            //* ! Stamp the redeem payload with the cart it was created for. Checkout only
            //* ! trusts a stored payload when cartID and userID both match, so a payload left
            //* ! behind by an abandoned redemption can't grant a delay on a later purchase.
            payload.cartID = res.cartID;

            console.log('productPayload:', productPayload);
            this.$store
              .dispatch('shop/addProductToCart', productPayload)
              .then(() => {
                //* Set params in local storage to preserve
                localStorage.setItem('redeem_productPayload', JSON.stringify(productPayload));
                localStorage.setItem('redeem_payload', JSON.stringify(payload));
                localStorage.setItem(
                  'redeem_licenseID',
                  license?.id ? license.id : productPayload?.license?.licenseId
                );
                //* Push to checkout page to finish setting up subscription
                this.$router
                  .push({
                    name: 'Checkout',
                    params: {
                      delayFirstPayment: true,
                      product,
                      licenseID: license?.id ? license.id : productPayload?.license?.licenseId,
                      payload,
                      productPayload,
                    },
                  })
                  .then(() => {
                    this.closeDialog();
                    this.isDualKey = false;
                    this.processingProductKey = false;
                    this.$store.dispatch('licenses/all');
                    //* If AGNOSTICLICENSE var is active, disable this mobile license call
                    // if (!isDev()) {
                    //   this.$store.dispatch('licenses/mobile');
                    // }
                  })
                  .catch(() => {
                    this.closeDialog();
                  });
              })
              .catch((err) => {
                try {
                  console.error('err:', err);
                  const { error } = err?.data || {};

                  if (error?.msg?.includes('pay and pause not allowed')) {
                    this.$root.vtoast.show({
                      text: `Error P1003B ${error?.code}: Unable to add additional time to subscription renewal at this time. Please try again in 24 hours.`,
                      color: 'error',
                      timeout: 12000,
                    });
                  } else {
                    this.$root.vtoast.show({
                      text: `Error P1003 ${error?.code}: ${error?.msg}.`,
                      color: 'error',
                    });
                  }
                  this.processingProductKey = false;
                  this.closeDialog();
                } catch (error) {
                  console.error('error:', error);
                  this.processingProductKey = false;
                  this.closeDialog();
                }
              });
          });
        })
        .catch((err) => {
          console.error(err);
          this.$root.vtoast.show({
            text: `Error P1005: Sorry, there was a problem processing this product key.`,
            color: 'error',
          });
          this.processingProductKey = false;
          this.closeDialog();
        });
    },

    //* Get product information so we can add it to the cart
    getProductPayload(license, product, products, createdLicenseID) {
      let regular;
      let discount;
      let reseller;
      let subscriptionProduct;

      //* If no single product, find subcription product
      if (isEmpty(product)) {
        subscriptionProduct = products?.find((product) => {
          const { productCategory, productType } = product;
          return (
            productCategory === 'licenseSubscription' ||
            productType.type.toLowerCase() === 'subscription'
          );
        });

        regular = subscriptionProduct?.pricings?.find((price) => {
          return price?.Active && price?.pricingType === 'regular';
        });
        discount = subscriptionProduct?.pricings?.find((price) => {
          return price?.Active && price?.pricingType === 'discount';
        });
        reseller = subscriptionProduct?.pricings?.find((price) => {
          return price?.Active && price?.pricingType === 'reseller';
        });
      } else {
        regular = this.product?.pricings?.find((price) => {
          return price?.Active && price?.pricingType === 'regular';
        });
        discount = this.product?.pricings?.find((price) => {
          return price?.Active && price?.pricingType === 'discount';
        });
        reseller = this.product?.pricings?.find((price) => {
          return price?.Active && price?.pricingType === 'reseller';
        });
      }

      console.log('regular:', regular);
      //* Needs a license - Check for id or appropriate dual key setting
      if ((!regular && !discount && !reseller) || (!license?.id && !createdLicenseID)) {
        this.$root.vtoast.show({
          text: `Error P1001: ${this.$t(
            'store.productCode.supportContactMsg'
          )} There appears to be missing information.`,
          color: 'error',
        });
        setTimeout(() => {
          this.processingProductKey = false;
          this.dialog = false;
        }, 1000);
        return;
      }

      const desktopProductType = this.productWhitelist?.some((item) => {
        return item.includes('desktop_license');
      });

      // Default to desktop type license only as of 10-15-24
      const productPayload = {
        ...product,
        ...subscriptionProduct,
        bypassDuplicateCheck: true,
        license: {
          licenseId: createdLicenseID || license?.id,
          type: license?.type
            ? license?.type?.toLowerCase()
            : desktopProductType
            ? 'desktop'
            : 'desktop',
          text: license?.text,
        },
        user: {
          id: this.getMe?.id,
        },
        setPrice:
          this.hasReseller && reseller?.Active ? reseller : discount?.Active ? discount : regular,
        multiKeyRedemption: !!products?.length,
      };
      return productPayload;
    },

    dismissKeyMessage(type, bypassDismiss = false) {
      this.productKey = '';
      this.addonKeyEnabled = false;
      this.selectedLicense = {};
      this.isSkuKey = false;
      this.isDualKey = false;
      this.product;
      this.isSubscription = false;
      this.hasLicense = false;
      this.isUserPermissionSingle = false;
      this.redeemedError = false;
      this.redeemedErrorMessage = null;
      if (type === 'success') {
        this.dialog = false;
      }
      if (!bypassDismiss) {
        this.$store.dispatch('licenses/dismissKeyMessage', false);
      }
      this.processingProductKey = false;
    },

    delayTouch($v) {
      $v.$reset();
      if (touchMap.has($v)) {
        clearTimeout(touchMap.get($v));
      }
      touchMap.set($v, setTimeout($v.$touch, 1000));
    },

    checkLicense(license) {
      let expired = false;
      const { expiresAt } = license?.license ?? {};
      if (!expiresAt) {
        return expired;
      }

      // * Check if license expiresAt is before today
      expired = expiresAt ? isBefore(parseISO(expiresAt), new Date()) : false;
      if (expired) {
        license.license.expiredLicense = expired;
      }
      return expired;
    },

    clearProductKeyField() {
      this.foundLicense = [];
      this.selectedLicense = {};
      this.hasSelectedLicense = false;
    },

    scanQR() {
      this.scan = true;
      this.camera = 'auto';
    },

    async onInit(promise) {
      // promise.catch(console.error).then(this.resetValidationState);

      //* show camera loading indicator
      this.loadingCamera = true;

      try {
        const { capabilities } = await promise;
        //* successfully initialized
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          //* user denied camera access permisson
          this.cameraAccessEnabled = false;
        } else if (error.name === 'InsecureContextError') {
          //* browser seems to be lacking features
          this.hasCameraAccess = false;
        } else if (error.name === 'NotFoundError') {
          //* no suitable camera device installed
          this.generalCameraError = true;
        } else if (error.name === 'NotSupportedError') {
          //* page is not served over HTTPS (or localhost)
          this.generalCameraError = true;
        } else if (error.name === 'NotReadableError') {
          //* maybe camera is already in use
          this.generalCameraError = true;
        } else if (error.name === 'OverconstrainedError') {
          //* did you requested the front camera although there is none?
          this.generalCameraError = true;
        } else if (error.name === 'StreamApiNotSupportedError') {
          //* browser seems to be lacking features
          this.generalCameraError = true;
        }
      } finally {
        //* hide camera loading indicator
        this.loadingCamera = false;
      }
    },

    async onDecode(content) {
      this.turnCameraOff();

      //* pretend it's taking really long
      await this.timeout(1000);
      this.isValid = this.prodKeyValidation(content);

      //* some more delay, so users have time to read the message
      await this.timeout(2000);
      this.productKeyChange(content); //* check product key

      if (this.validationFailure) {
        this.turnCameraOn();
      } else {
        this.productKey = content;
        this.turnCameraOff();
        this.scan = false;
        this.resetValidationState();
        this.loadingCamera = false;
      }
    },

    turnCameraOn() {
      this.camera = 'auto';
    },

    turnCameraOff() {
      this.camera = 'off';
    },

    resetValidationState() {
      this.isValid = undefined;
      this.hasCameraAccess = undefined;
      this.cameraAccessEnabled = undefined;
      this.loadingCamera = false;
    },

    timeout(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms);
      });
    },

    prodKeyValidation(val) {
      const pattern = /([A-Za-z0-9]){5}-([A-Za-z0-9]){5}-([A-Za-z0-9]){5}-([A-Za-z0-9]){5}/;
      return pattern.test(val?.trim());
    },

    paintOutline(detectedCodes, ctx) {
      for (const detectedCode of detectedCodes) {
        const [firstPoint, ...otherPoints] = detectedCode.cornerPoints;

        ctx.strokeStyle = 'red';

        ctx.beginPath();
        ctx.moveTo(firstPoint.x, firstPoint.y);
        for (const { x, y } of otherPoints) {
          ctx.lineTo(x, y);
        }
        ctx.lineTo(firstPoint.x, firstPoint.y);
        ctx.closePath();
        ctx.stroke();
      }
    },

    // Dialog open to confirm and wait for response on new license creation
    openDialog(dialogOption = null) {
      if (!dialogOption) {
        return;
      }
      this[dialogOption] = true;

      return new Promise((resolve) => {
        this.dialogResolve = resolve; // Store the resolver
      });
    },

    // Response handling for waiting for user to confirm new license creation
    handleDialogResponse(response, dialogOption) {
      this[dialogOption] = false;
      if (this.dialogResolve) {
        this.dialogResolve(response); // Resolve the promise with the user response
        this.dialogResolve = null; // Clean up the resolver
      }
    },
  },
};
</script>

<style scoped>
.product-code {
  margin-top: 50px;
  margin-bottom: 50px;
}

.product-code {
  height: 10vh;
  min-height: 10vh !important;
}

.product-code-minimal {
  margin-top: 0;
  margin-bottom: 0;
  height: 100px;
  min-height: 90px !important;
}

.product-code .v-card {
  border-radius: var(--border-10, 10px);
}

.product-code-headline {
  text-transform: uppercase;
}

.custom-button {
  height: 64px !important;
  /* width: 250px; */ /** This was originally added with container width */
  margin: 20px auto;
  margin-top: 20px;
  font-size: 1rem !important;
  font-weight: 400;
}

.custom-button-dark {
  background-color: var(--grey, #6d6d6d) !important;
}

.license-list {
  max-height: 150px;
  overflow: auto;
  padding: 5px;
  border: 1px solid var(--grey-lighter, #a6a7a9);
  border-radius: 5px;
}

.subheading-block {
  display: block;
}

.more-icon {
  position: absolute;
  bottom: 0;
  right: 25px;
}

.progress-camera {
  margin-top: 75px;
}

.qr-btn {
  margin: 0 auto;
}

.loading-box {
  position: absolute;
  top: 25%;
  left: 33%;
}

/* .camera-loading {
  height: 450px;
  width: 360px;
} */

.validation-success,
.validation-failure,
.validation-pending {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  font-weight: bold;
  font-size: 1.4rem;
  padding: 10px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}
.validation-success {
  color: var(--success, green);
}

.validation-failure {
  color: var(--primary, #ba2127);
}

@media (max-width: 1280px) {
  /** This was originally added with container width */
  /* .custom-button {
    width: 200px;
  } */
}

@media (max-width: 1265px) {
  /** This was originally added with container width */
  /* .custom-button {
    width: 250px;
  } */
}

@media (max-width: 960px) {
  .custom-button {
    /* width: 170px; */ /** This was originally added with container width */
    font-size: 16px;
  }
}

@media (max-width: 600px) {
  .product-code {
    height: 32vh;
    min-height: 30vh;
  }
  .product-code .v-card {
    height: 31vh !important;
    min-height: 30vh !important;
  }

  /** This was originally added with container width */
  /* .custom-button {
    width: 95%;
  } */

  .qr-btn {
    padding: 15px 0;
  }
  .qr-btn button {
    width: 50px;
    height: 50px;
  }
  .qr-btn button i {
    font-size: 50px !important;
  }
  .loading-box {
    top: 25%;
    left: 25%;
  }
}
</style>
